{
  "scheduling": "Đặt lịch hẹn",
  "date": "Ngày",
  "time": "Giờ",
  "duration": "Thời lượng",
  "provider": "Bác sĩ",
  "reason": "Lý do",
  "status": "Trạng thái",
  "statusOptions": {
    "scheduled": "Đã đặt lịch",
    "confirmed": "Đã xác nhận",
    "arrived": "Đã đến",
    "checked-in": "Đã đăng ký",
    "in-progress": "Đang thực hiện",
    "completed": "Hoàn thành",
    "cancelled": "Đã hủy",
    "no-show": "Vắng mặt"
  },
  "coverageScope": {
    "panel": "Danh sách bệnh nhân",
    "unit": "Đơn vị",
    "facility": "Toàn cơ sở"
  },
  "coverageScopeDescription": {
    "panel": "Chỉ riêng danh sách bệnh nhân của bác sĩ được thay thế.",
    "unit": "Đơn vị được phân công của bác sĩ được thay thế.",
    "facility": "Toàn cơ sở — thường là sắp xếp trực gọi."
  },
  "dayShort": {
    "0": "CN",
    "1": "T2",
    "2": "T3",
    "3": "T4",
    "4": "T5",
    "5": "T6",
    "6": "T7"
  },
  "blockType": {
    "available": "Có sẵn",
    "blocked": "Đã chặn"
  },
  "appointmentTypes": {
    "followUp": "Tái khám",
    "newPatient": "Bệnh nhân mới",
    "consultation": "Tư vấn",
    "procedure": "Thủ thuật",
    "urgent": "Khẩn cấp",
    "wellnessCheck": "Khám sức khỏe",
    "physical": "Khám tổng quát",
    "telemedicine": "Khám từ xa",
    "scheduleTemplate": "Mẫu lịch"
  },
  "pages": {
    "providerDirectory": {
      "title": "Danh bạ bác sĩ",
      "subtitle": "Duyệt và tìm kiếm nhà cung cấp dịch vụ y tế",
      "search": {
        "namePlaceholder": "Tìm theo tên...",
        "specialtyPlaceholder": "Tìm theo chuyên khoa..."
      },
      "filters": {
        "facilityAriaLabel": "Lọc theo cơ sở",
        "departmentAriaLabel": "Lọc theo khoa",
        "allFacilities": "Tất cả cơ sở",
        "allDepartments": "Tất cả khoa"
      },
      "loading": "Đang tải danh sách bác sĩ...",
      "loadError": "Không tải được danh bạ bác sĩ.",
      "empty": "Không tìm thấy bác sĩ nào phù hợp với tiêu chí của bạn.",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "Tạo mẫu lịch trực",
      "labels": {
        "provider": "Bác sĩ",
        "dayOfWeek": "Thứ trong tuần",
        "startTime": "Giờ bắt đầu",
        "endTime": "Giờ kết thúc",
        "slotDuration": "Độ dài khung giờ (phút)",
        "templateName": "Tên mẫu",
        "effectiveStartDate": "Có hiệu lực từ"
      },
      "slotDurationOption": "{{minutes}} phút",
      "buttons": {
        "cancel": "Hủy",
        "save": "Lưu mẫu"
      },
      "toast": {
        "success": "Đã lưu mẫu lịch trực",
        "failure": "Lưu mẫu lịch trực thất bại"
      },
      "placeholders": {
        "templateName": "vd. Phòng khám sáng thứ Hai"
      },
      "defaultName": "Lịch {{day}}"
    },
    "scheduleManagement": {
      "title": "Quản lý Lịch trực",
      "backToDashboard": "← Bảng điều khiển",
      "newTemplate": "Mẫu Mới",
      "today": "Hôm nay",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "Khung {{minutes}} phút",
      "legend": {
        "booked": "Đã đặt"
      },
      "upcomingAppointmentsHeading": "Lịch hẹn sắp tới - {{providerName}}",
      "loadingAppointments": "Đang tải lịch hẹn...",
      "unknownPatient": "Bệnh nhân không xác định",
      "fallbackAppointmentType": "Tổng quát",
      "noUpcomingAppointments": "Không có lịch hẹn sắp tới cho bác sĩ này"
    },
    "providerCoverage": {
      "title": "Phân công thay thế",
      "subtitle": "Phân công thay thế ca có thời hạn — bàn giao danh sách bệnh nhân cho đồng nghiệp trong khoảng thời gian xác định. Khác với truy cập khẩn cấp; dùng cho nghỉ phép, xoay vòng trực gọi và vắng mặt theo kế hoạch.",
      "actions": {
        "newCoverage": "Phân công mới",
        "cancel": "Hủy"
      },
      "form": {
        "title": "Sắp xếp thay thế mới",
        "labels": {
          "coveredProviderId": "Bác sĩ được thay thế",
          "coveringProviderId": "Bác sĩ thay thế",
          "scope": "Phạm vi",
          "from": "Từ",
          "until": "Đến",
          "reason": "Lý do"
        },
        "placeholders": {
          "coveredProviderId": "Bác sĩ có danh sách bệnh nhân được phụ trách",
          "coveringProviderId": "Bác sĩ tiếp quản trong khoảng thời gian",
          "reason": "vd. Nghỉ phép 22–29/4; trực gọi cuối tuần"
        },
        "help": {
          "coveredProviderId": "Không có COVERAGE_ADMIN, đây phải là chính bạn.",
          "coveringProviderId": "Tìm theo tên rồi chọn — không bao giờ giao phiên trực cho ID gõ tay."
        },
        "aria": {
          "effectiveFromDate": "Ngày bắt đầu hiệu lực",
          "effectiveFromTime": "Giờ bắt đầu hiệu lực",
          "effectiveUntilDate": "Ngày kết thúc hiệu lực",
          "effectiveUntilTime": "Giờ kết thúc hiệu lực"
        },
        "buttons": {
          "cancel": "Hủy",
          "create": "Tạo phân công thay thế"
        },
        "typeaheadEmpty": "Không tìm thấy bác sĩ"
      },
      "sections": {
        "mine": {
          "title": "Phân công của tôi",
          "subtitle": "Phân công nơi tôi là bác sĩ thay thế hoặc được thay thế.",
          "empty": "Không có phân công nào được ghi lại."
        },
        "all": {
          "title": "Tất cả phân công",
          "subtitle": "Mọi sắp xếp thay thế trong tổ chức. Chế độ quản trị viên.",
          "empty": "Không có phân công nào. Hoặc là tin tốt, hoặc là bộ lọc cũ."
        }
      },
      "list": {
        "coveringConnector": "thay thế cho",
        "groups": {
          "active": "Đang hoạt động ({{count}})",
          "planned": "Đã lên kế hoạch / Đã qua ({{count}})",
          "revoked": "Đã hủy ({{count}})"
        },
        "untilRevoked": "đến khi bị hủy",
        "revokedPrefix": "Đã hủy",
        "revokeTitle": "Hủy"
      },
      "revokeDialog": {
        "title": "Hủy phân công thay thế?",
        "description": "{{coveringProviderName}} sẽ không còn thay thế cho {{coveredProviderName}}. Bản ghi vẫn còn trong nhật ký kiểm toán.",
        "confirm": "Hủy",
        "reasonPlaceholder": "Lý do kết thúc việc trực thay này (không bắt buộc)"
      },
      "toast": {
        "created": "Đã tạo phân công thay thế",
        "revoked": "Đã hủy phân công thay thế",
        "invalid": "Phân công không hợp lệ — kiểm tra bác sĩ và ngày tháng",
        "forbidden": "Không được phép tạo phân công cho bác sĩ này",
        "createFailed": "Không tạo được phân công thay thế",
        "revokeFailed": "Không hủy được phân công thay thế"
      }
    },
    "appointments": {
      "title": "Lịch hẹn",
      "subtitle": "Lập lịch và quản lý các lịch hẹn của bệnh nhân",
      "actions": {
        "refresh": "Làm mới",
        "schedule": "Lập lịch hẹn",
        "arriveTitle": "Ghi nhận đến",
        "arriveAria": "Ghi nhận {{patientName}} đã đến",
        "checkInTitle": "Đăng ký",
        "checkInAria": "Đăng ký {{patientName}}",
        "rescheduleTitle": "Đổi lịch",
        "rescheduleAria": "Đổi lịch {{patientName}}",
        "cancelTitle": "Hủy",
        "cancelAria": "Hủy lịch hẹn của {{patientName}}",
        "checkedInLabel": "Đã đăng ký",
        "startVisitTitle": "Bắt đầu khám",
        "startVisitAria": "Bắt đầu khám cho {{patientName}}"
      },
      "weekNav": {
        "previous": "Tuần trước",
        "previousAria": "Tuần trước",
        "next": "Tuần sau",
        "nextAria": "Tuần sau"
      },
      "calendar": {
        "gridAria": "Lịch hẹn theo tuần",
        "timeColumn": "Giờ",
        "loading": "Đang tải lịch...",
        "cellAria": "{{dayLabel}} {{date}} lúc {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "Lịch hẹn sắp tới",
        "empty": "Không có lịch hẹn nào trong tuần này",
        "durationMinutes": "{{minutes}} phút",
        "columns": {
          "dateTime": "Ngày / Giờ",
          "patient": "Bệnh nhân",
          "type": "Loại",
          "provider": "Bác sĩ",
          "duration": "Thời lượng",
          "status": "Trạng thái",
          "actions": "Thao tác"
        }
      },
      "toast": {
        "cancelled": "Đã hủy lịch hẹn",
        "cancelFailed": "Hủy lịch hẹn thất bại",
        "visitStarted": "Đã bắt đầu khám",
        "startVisitFailed": "Không thể bắt đầu khám",
        "arrivalRecorded": "Đã ghi nhận đến",
        "arrivalFailed": "Không thể ghi nhận đến"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "Đặt lịch hẹn mới",
        "edit": "Đổi lịch hẹn"
      },
      "labels": {
        "patient": "Bệnh nhân",
        "appointmentType": "Loại lịch hẹn",
        "provider": "Bác sĩ",
        "scheduledAt": "Thời gian hẹn",
        "duration": "Thời lượng",
        "reason": "Lý do khám"
      },
      "placeholders": {
        "patientSearch": "Tìm bệnh nhân theo tên hoặc MRN...",
        "provider": "Tên bác sĩ",
        "reason": "Lý do khám ngắn gọn..."
      },
      "patientTypeahead": {
        "empty": "Không tìm thấy bệnh nhân"
      },
      "aria": {
        "appointmentDate": "Ngày hẹn",
        "appointmentTime": "Giờ hẹn"
      },
      "durationOption": "{{minutes}} phút",
      "buttons": {
        "cancel": "Hủy",
        "schedule": "Đặt lịch hẹn",
        "update": "Cập nhật lịch hẹn"
      },
      "toast": {
        "created": "Đã tạo lịch hẹn thành công",
        "updated": "Lịch hẹn đã được cập nhật",
        "createFailed": "Tạo lịch hẹn thất bại",
        "updateFailed": "Cập nhật lịch hẹn thất bại"
      },
      "validation": {
        "patientRequired": "Vui lòng chọn bệnh nhân",
        "appointmentTypeRequired": "Loại lịch hẹn là bắt buộc",
        "scheduledAtRequired": "Vui lòng nhập ngày và giờ",
        "durationInvalid": "Thời lượng phải từ 1 đến 480 phút",
        "providerRequired": "Vui lòng chọn bác sĩ"
      },
      "providerTypeahead": {
        "empty": "Không tìm thấy bác sĩ"
      },
      "loadingEdit": "Đang tải lịch hẹn…",
      "loadEditError": "Không thể tải lịch hẹn này.",
      "patientLocked": "Không thể đổi bệnh nhân khi dời lịch hẹn."
    },
    "waitlist": {
      "title": "Danh sách chờ lịch hẹn",
      "backToDashboard": "← Bảng điều khiển",
      "entryCount": "{{count}} mục",
      "searchPlaceholder": "Tìm theo tên bệnh nhân, MRN hoặc ghi chú...",
      "clearSearchAria": "Xóa tìm kiếm",
      "filters": {
        "allProviders": "Tất cả bác sĩ",
        "allTypes": "Tất cả loại",
        "providerAriaLabel": "Lọc theo bác sĩ",
        "typeAriaLabel": "Lọc theo loại lịch hẹn"
      },
      "columns": {
        "patient": "Bệnh nhân",
        "provider": "Bác sĩ",
        "type": "Loại",
        "priority": "Mức ưu tiên",
        "requestedDates": "Ngày yêu cầu",
        "dateAdded": "Ngày thêm",
        "notes": "Ghi chú",
        "actions": "Hành động",
        "reason": "Lý do"
      },
      "priority": {
        "urgent": "Khẩn cấp",
        "routine": "Thông thường",
        "flexible": "Linh hoạt"
      },
      "actions": {
        "scheduleTitle": "Đặt lịch hẹn",
        "editPriorityTitle": "Sửa mức ưu tiên",
        "removeTitle": "Xóa khỏi danh sách chờ"
      },
      "empty": "Không có mục nào trong danh sách chờ khớp với bộ lọc",
      "loadFailed": "Không thể tải danh sách chờ. Hãy kiểm tra kết nối và thử lại.",
      "modal": {
        "title": "Đặt lịch hẹn",
        "closeAria": "Đóng",
        "providerLabel": "Bác sĩ:",
        "requestedLabel": "Yêu cầu:",
        "dateTimeLabel": "Ngày & giờ lịch hẹn *",
        "dateAria": "Ngày lịch hẹn",
        "timeAria": "Giờ lịch hẹn",
        "requestedWindow": "Khoảng thời gian yêu cầu: {{start}} — {{end}}",
        "cancel": "Hủy",
        "submit": "Đặt lịch"
      },
      "toasts": {
        "removed": "Đã xóa khỏi danh sách chờ",
        "priorityUpdated": "Đã cập nhật mức ưu tiên",
        "scheduled": "Đã đặt lịch hẹn và xóa khỏi danh sách chờ",
        "dateTimeRequired": "Vui lòng chọn ngày và giờ",
        "updateFailed": "Không thể cập nhật danh sách chờ",
        "promoteOrphaned": "Lịch hẹn đã được tạo nhưng không thể cập nhật mục trong danh sách chờ. Hãy kiểm tra lịch trước khi thử lại."
      }
    },
    "checkIn": {
      "title": "Tiếp nhận bệnh nhân",
      "subtitle": "Tiếp nhận — bảo hiểm, phê duyệt và đồng chi trả. Bệnh nhân đã đến.",
      "fields": {
        "insuranceId": "Bảo hiểm",
        "copayAmount": "Số tiền đồng chi trả",
        "copayCollected": "Đã thu đồng chi trả",
        "authorizationNumber": "Số phê duyệt",
        "authorizationVerified": "Đã xác minh phê duyệt"
      },
      "copayHint": "Đánh dấu đã thu đồng chi trả sẽ ghi một khoản thanh toán vào tài khoản bệnh nhân.",
      "submit": "Hoàn tất tiếp nhận",
      "cancel": "Hủy",
      "toast": {
        "success": "Đã tiếp nhận bệnh nhân",
        "failed": "Không thể tiếp nhận bệnh nhân"
      }
    },
    "providerTypeahead": {
      "loadError": "Không thể tải danh bạ bác sĩ — hãy kiểm tra kết nối và thử lại.",
      "retry": "Thử lại"
    }
  }
}
